function required(name) {
  const v = process.env[name];
  if (!v || !String(v).trim()) {
    throw new Error(
      `Missing ${name}. Copy .env.example to .env.local and add your Firebase Web SDK config.`
    );
  }
  return v.trim();
}

const measurementId = process.env.REACT_APP_FIREBASE_MEASUREMENT_ID?.trim();

export const firebaseConfig = {
  apiKey: required("REACT_APP_FIREBASE_API_KEY"),
  authDomain: required("REACT_APP_FIREBASE_AUTH_DOMAIN"),
  projectId: required("REACT_APP_FIREBASE_PROJECT_ID"),
  storageBucket: required("REACT_APP_FIREBASE_STORAGE_BUCKET"),
  messagingSenderId: required("REACT_APP_FIREBASE_MESSAGING_SENDER_ID"),
  appId: required("REACT_APP_FIREBASE_APP_ID"),
  ...(measurementId ? { measurementId } : {}),
};

export const verificationEmailUrl =
  process.env.REACT_APP_VERIFICATION_EMAIL_URL?.trim() || "";
